import styled from "styled-components";

export const ErrorMessageStyled = styled.div`
  color: red;
  margin-top: 4px;
  font-size: 14px;
  display: block;
`;
